import ztUi from '@linktivity/link-ui/lang/zt';
import country from '@link/share/i18n/country/zt';

import japanPrefectures from '@link/share/i18n/japanPrefectures/zt';
import {
  NotificationType,
  PaymentType,
  PaymentPeriod,
  BookingType,
  IssuedStatus,
  CancelReason,
  ConfirmationType,
  DiscrepancyType,
  DiscrepancyReason,
  DiscrepancyStatus,
  DiscrepancyWaitingStatus,
  DiscrepancyInitiator,
  NotificationMethod,
  WalletOrderStatus,
  TransactionTypeMap
} from '@link/share/services/const';

export default {
  ...ztUi,
  country,
  japanPrefectures,
  common: {
    account: '帳戶',
    signOut: '登出',
    status: '狀態',
    action: '操作',
    parenthesis: '({{text}})',
    detail: '詳細',
    edit: '編輯',
    add: '添加',
    save: '儲存',
    or: '或者',
    delete: '刪除',
    formTitle: '{{id}}（{{title}}）',
    withSpace: '{{val1}} {{val2}}',
    withDashSeparated: '{{val1}} - {{val2}}',
    withSlashSeparated: '{{val1}} × {{val2}}',
    withCommaSeparated: '{{val1}} / {{val2}}',
    slash: '/',
    confirm: '確定',
    editConfirm: '編輯確認',
    ON: '開啟',
    OFF: '關閉',
    cancel: '取消',
    confirmDelete: '您確定要刪除 {{name}} 嗎？',
    yes: '是',
    no: '否',
    close: '關閉',
    has: '有',
    hasNot: '無',
    verify: '確認',
    register: '註冊',
    continueEditing: '繼續編輯',
    leaveCurrentPage: '離開此頁面',
    leaveCurrentPageConfirm: '{{name}} 仍在編輯中。',
    separator: '，',
    pdf: 'PDF',
    mobile: '手機',
    rangeSymbol: '~',
    pc: 'PC',
    grossPrice: '售價金額',
    netPrice: '淨金額',
    sender: '寄件者',
    approver: '承認者',
    discrepancy: '差額調整內容',
    adjustmentAmount: '調整金額',
    commission: '傭金',
    cancelFee: '取消手續費',
    refundAmount: '退款金額',
    arrow: '→',
    colon: '：',
    empty: '暫無數據',
    viewDetail: '查看詳情',
    voucher: '憑證',
    printableVoucher: '打印',
    forDisplayVoucher: '電子',
    supplier: '供應商',
    agent: '旅行社',
    complete: '完成',
    denied: '拒絕',
    downloadDetails: '下載明細',
    total: '搜尋結果：{{total}} 筆',
    infoSent: '資訊已發送至{{target}}。',
    currency: '貨幣',
    zip: 'ZIP',
    excel: 'CSV',
    download: '下載',
    manual: '使用手冊'
  },
  views: {
    contractsList: {
      title: '銷售權限設置狀況',
      supplier: '供應商（ID）',
      agent: '旅行社（ID）',
      systemChargePercent: '目前系統費用（%）',
      supplierCountry: '供應商（國家/地區）',
      agentCountry: '旅行社（國家/地區）'
    },
    contractDetail: {
      addTitle: '新增合約',
      editTitle: '編輯合約',
      title: '合約詳情',
      form: {
        supplier: '供應商',
        agent: '旅行社',
        status: '狀態',
        systemChargePercent: '目前系統費用（%）'
      }
    },
    suppliersList: {
      supplierCustomId: '供應商（ID）'
    },
    suppliersDetail: {
      title: '公司資訊',
      supplierCustomId: '供應商 ID',
      originalName: '供應商名',
      englishName: '供應商（英文名）',
      status: '狀態',
      mainLanguage: '使用語言',
      salesAccounts: '業務負責人',
      webUrl: '官方網址',
      countryCode: '國家/地區',
      categories: '分類',
      registrationCode: '發票開立事業者登錄號碼',
      logoUrl: 'Logo',
      privacyPolicyType: '隱私政策處理',
      currency: '使用貨幣',
      transferFeePayer: '匯款手續費支付',
      billingMethod: '付款方式',
      systemFeeRefundPolicyCustomer: '系統使用費退款（客戶取消）',
      systemFeeRefundPolicySupplier: '系統使用費退款（供應商取消）',
      systemFeeRefundPolicyInvalid: '系統使用費退款（無效化處理）'
    },
    suppliersAccount: {
      title: '帳戶管理',
      role: '權限',
      supplierCustomId: '供應商',
      loginId: '電子郵件',
      username: '使用者名稱',
      supportLanguages: '使用語言'
    },
    suppliersAccountDetail: {
      addTitle: '新增帳戶',
      editTitle: '帳戶編輯',
      supplierId: '供應商',
      loginId: '電子郵件地址（登入ID）',
      password: '密碼',
      supportLanguages: '使用語言',
      role: '權限',
      notificationType: '通知類型',
      username: '使用者名稱',
      phoneNumber: '電話號碼',
      personInCharge: '負責人姓名',
      department: '部門/職位',
      receiveNotifications: '接收通知',
      notificationMethod: '通知接收方式',
      requireMfa: '兩步驟驗證'
    },
    newAgent: {
      otaCustomId: '旅行社 ID',
      title: '新增旅行社',
      originalName: '旅行社名稱',
      englishName: '旅行社名稱（英文名）',
      contractType: '已簽署合約',
      mainLanguage: '主要語言',
      salesAccounts: '業務負責人',
      webUrl: '官方網址',
      country: '國家/地區',
      currency: '使用貨幣',
      logoUrl: 'Logo',
      paymentType: '支付方式',
      paymentPeriod: '結算週期'
    },
    agentAccountList: {
      role: '權限',
      org: '所屬群組',
      loginId: '使用者ID',
      username: '使用者名稱',
      supportLanguages: '使用語言'
    },
    newAgentAccount: {
      title: '新增帳戶',
      otaId: '旅行社',
      otaOrgId: '所屬群組',
      loginId: '電子郵件地址（登入ID）',
      password: '密碼',
      role: '權限',
      supportLanguages: '使用語言',
      notificationType: '通知類型',
      username: '使用者名稱',
      phoneNumber: '電話號碼',
      personInCharge: '負責人姓名',
      department: '部門/職位',
      requireMfa: '兩步驟驗證'
    },
    orgList: {
      country: '國家/地區',
      parentOtaOrg: '上層群組',
      otaOrgName: '群組名稱'
    },
    newOrg: {
      title: '新增群組',
      otaOrgCustomId: '群組 ID',
      otaOrgName: '群組名稱',
      otaId: '旅行社',
      otaOrgId: '群組 ID',
      parentOtaOrgId: '上層群組',
      countryCode: '國家/地區',
      logoUrl: 'Logo',
      activityIdWhitelist: '商品銷售設定'
    },
    login: {
      title: '歡迎來到GDS',
      email: '電子郵件',
      password: '密碼',
      button: '登入',
      success: '已登入',
      link: '忘記密碼請點此',
      resettitle: '密碼重設',
      reset: '發送密碼重設郵件',
      send: '已將密碼重設連結發送至{{email}}，請至信箱確認並重新設定密碼。',
      resetError: '郵件發送失敗，請稍後再試。',
      googleLogin: '使用 Google 帳戶登入',
      register: '新規註冊／聯絡我們請點此',
      privacy: '隱私政策',
      ipNotAllowed: '目前網路錯誤，請再試一次。'
    },
    enrollOTP: {
      title: '設定雙重驗證',
      description: '為了增強帳號安全性，請使用認證應用程式掃描QR碼',
      step1: '1. 在智慧手機上安裝 Google Authenticator',
      appStore: 'App Store (iOS)',
      googlePlay: 'Google Play (Android)',
      step2: '2. 掃描QR碼',
      step3: '3. 輸入顯示的6位數字完成設定',
      qrLabel: 'QR碼',
      codeLabel: '認證應用程式的6位數字',
      submit: '確認並啟用',
      enrollError: '驗證碼不正確，請重試'
    },
    verifyOTP: {
      title: '雙重驗證',
      code: '驗證碼',
      verify: '確認',
      verifyError: '驗證碼不正確，請重試'
    },
    changePassword: {
      title: '修改密碼',
      oldPassword: '目前【密碼】',
      newPassword: '新【密碼】'
    },
    booking: {
      bookingCustomId: '預訂編號',
      status: '狀態',
      purchasedDate: '申請日',
      participationDate: '參加日',
      freeSale: '無庫存限制',
      participationTime: '開始時間',
      activityTitleSupplierLang: '商品',
      planTitle: '方案',
      orderCount: '數量',
      firstName: '參加者姓名',
      participantResidentRegion: '參加者居住國家/地區',
      participantEmailAddress: '參加者電子郵件',
      destinationEmail: '聯絡資訊',
      agentReservationNote: '旅行社預訂編號',
      agentBookingIdRemark: '旅行社預訂編號（備註）',
      agentReservationSpecialNote: '旅行社預訂特別備註',
      supplierBookingId: '供應商的預訂號碼',
      bookingDetail: '預訂詳情',
      bookingNumber: '預訂編號',
      parentBookingNumber: '關聯預約編號',
      bookingType: '購買類別',
      applicationDate: '申請日',
      bookingStatus: '預訂狀態',
      cancelledBySupplier: '由供應商操作',
      issuedStatus: '使用狀態',
      bookerName: '預訂代表者姓名',
      product: '商品/方案',
      productVoucherLang: '商品/方案（預訂語言）',
      voucherExpiration: '憑證有效期限',
      paymentInfo: '付款資訊',
      salePrice: '銷售價格',
      commission: '手續費',
      netPrice: '批發價格',
      free: '無庫存限制',
      individual: '個別',
      download: '下載',
      exchangeUrl: '兌換用URL',
      openUrl: '開啟URL',
      discrepancies: '差額調整',
      cancelBooking: '取消預訂',
      invalidBookingBtn: '預訂無效',
      invalidBooking: '是否要使此預訂無效？',
      invalidBookingConfirmP1: '是否要使所選預約無效？',
      invalidBookingConfirmP2: '此操作無法復原，請在繼續前確認內容。',
      invalidBookingConfirmP3: '作廢後於請款書的反映方式，可在下一步進行選擇。',
      invalidBookingConfirmText: '作廢',
      invalidBookingConfirmProcessing: '此為處理中的預約，仍要作廢嗎？',
      invalidBookingSecondTitle: '請選擇結算書的反映方式',
      invalidBookingOpt1Title: '1. 反映至預約確認日所屬月份（或週）的結算書',
      invalidBookingOpt1P1:
        '本次預約將以全額退款形式，反映至預約確認日所屬月份（或週）的結算書中。',
      invalidBookingOpt1P2:
        '若執行作廢操作的日期已超過預約確認日所屬月份（或週）的結算截止日，且結算書已發行，則該月份（或週）的結算書將被重新發行。',
      invalidBookingOpt1P3:
        '作廢處理完成後，請務必重新下載並確認最新版本的結算書。',
      invalidBookingOpt1P4: '此外，本次預約資訊',
      invalidBookingOpt1P5:
        '將不會顯示於執行作廢操作日期所屬月份（或週）的結算書中。',
      invalidBookingOpt2Title:
        '2. 反映至執行作廢操作日期所屬月份（或週）的結算書',
      invalidBookingOpt2P1:
        '本次預約將以全額退款形式，反映至執行作廢操作日期所屬月份（或週）的結算書中。',
      invalidBookingOpt2P2:
        '即使執行作廢操作的日期已超過預約確認日所屬月份（或週）的結算截止日且結算書已發行，結算書也不會被重新發行。',
      cancelFeeAndRefundAmount: '取消手續費與退款金額',
      currentDateTime: '目前日期和時間',
      amount: '數量',
      paidAmount: '付款金額',
      cancelFee: '取消費用',
      refundAmount: '退款金額',
      confirmedBy: '確認者姓名',
      performCancel: '取消',
      cancelResult: '取消完成',
      cancelSucceed: '取消成功',
      cancelPending: '取消處理中，等待供應商回覆。',
      unitAdditionalLabel: '{{unitTitle}}{{unitIndex}}的追加預訂資訊',
      cancelReason: '取消原因',
      cancelComment: '取消備註',
      denyReason: '拒絕原因',
      name: '{{firstName}} {{lastName}}',
      otaName: '銷售方名稱',
      endUserRefundAmount: '終端用戶退款金額',
      paymentRefundAmount: '退款金額',
      cancelFeeFromTravelerToAgent: '取消手續費（旅客至代理商）',
      cancelFeeFromAgentToLink: '取消手續費（代理商至LINKTIVITY）',
      finalSettlementToLink: '最終結算金額（至LINKTIVITY）',
      paymentRefundAmountOta: '退款金額（代理商）',
      cancelFeeFromLinkToSupplier: '取消手續費（LINKTIVITY至供應商）',
      systemCharge: '系統費用',
      finalSettlementFromLink: '最終結算金額（來自LINKTIVITY）',
      linkCancelFee: '取消手續費（LINKTIVITY回收部分）',
      linkRevenue: 'LINKTIVITY收益'
    },
    discrepancies: {
      title: '差額調整申請{{type}}',
      finished: '已發送',
      return: '返回預訂詳情',
      send: '發送',
      receive: '接收',
      discrepancy: '差額調整',
      discrepancyType: '調整內容',
      reasonDescription: '詳細',
      reason: '理由',
      priceAdjust: '調整金額（差額）',
      grossAdjustmentAmount: '銷售價格',
      netAdjustmentAmount: '批發價格',
      addItem: '新增項目',
      bookingInfo: '預訂資訊',
      adjustmentItem: '調整項目',
      verifier: '確認者姓名',
      applicant: '申請者',
      enterName: '請輸入姓名',
      apply: '提交申請',
      adjustmentAmount: '調整金額',
      originalGrossAmount: '原銷售價格',
      originalNetAmount: '原批發價格',
      adjustedGrossAmount: '調整後的銷售價格',
      adjustedNetAmount: '調整後的批發價格',
      requiredAmount: '請輸入金額',
      applySuccessTitle: '已送出差額調整申請',
      approveSuccessTitle: '已核准差額調整申請',
      denySuccessTitle: '已拒絕差額調整申請',
      successMsg: '已核准的調整金額將反映於最近的付款月份。',
      alert: '確認後，輸入的差額調整項目將送至{{target}}進行審核。',
      waitingTip: '已將以下調整項目送至{{target}}，目前等待{{target}}審核。',
      reviewTip: '是否核准以下差額調整項目？',
      approve: '核准',
      deny: '拒絕'
    },
    bookingList: {
      title: '預訂管理',
      filter: {
        bookingCustomId: '預訂編號',
        activityTitle: '商品名',
        planTitle: '方案名',
        status: '狀態',
        participantName: '預訂代表者姓名',
        participantEmail: '預訂代表者電子郵件地址',
        purchasedAtStart: '申請日',
        participateDateStart: '參加日期（本地產品）',
        agentReservationNo: '旅行社預訂號碼',
        supplierBookingId: '供應商的預訂號碼'
      },
      participantResidentRegion: '國家/地區'
    },
    bulkBookingList: {
      title: '預訂管理',
      reservationNumber: '預訂編號',
      status: '狀態',
      submitDate: '提交日',
      product: '商品',
      plan: '方案',
      agent: '旅行社'
    },
    discrepancyList: {
      title: '差額調整',
      purchaseDate: '購買日',
      participationDate: '參加日',
      keyword: '關鍵字',
      activity: '商品',
      plan: '方案',
      reservationNumber: '預訂編號',
      transactionType: '交易類型',
      adjustmentStatus: '調整狀態',
      salesPrice: '銷售價格',
      wholesalePrice: '批發價格',
      sender: '寄件者',
      senderFormat: '{{senderName}} ({{initiator}})'
    },
    notificationInbox: {
      title: '通知列表',
      all: '全部 ({{count}})',
      summary: '共 {{total}} 筆 · 未讀 {{unread}} 筆',
      empty: '暫無通知',
      detailPlaceholder: '請在左側選擇通知以查看詳情。',
      detailLoadError: '取得通知詳情失敗'
    },
    invoiceChange: {
      title: '金額調整',
      adjustmentDate: '調整日期',
      adjustedBy: '調整者',
      invoiceAmount: '請款金額',
      adjustmentAmount: '調整金額',
      paymentAmount: '付款金額',
      adjustmentReason: '調整原因',
      submit: '確認',
      addFile: '上傳檔案',
      historyTitle: '金額調整歷史記錄',
      finalAmount: '調整後的付款金額'
    }
  },
  const: {
    cancelErrorCode: {
      BOOKING_NOT_FOUND: '找不到該預訂',
      BOOKING_ALREADY_CANCELLED: '已經取消',
      CANCEL_DEADLINE_PASSED: '已超過取消期限',
      BOOKING_ALREADY_ISSUED: '此預訂已開票，不可取消',
      BOOKING_STATUS_NOT_CANCELLABLE: '此預訂在目前狀態下不可取消',
      BOOKING_INVALIDATION_IN_PROGRESS: '此預訂正在無效化處理中，不可取消',
      BOOKING_DECLINE_INSTEAD_OF_CANCEL: '此預訂需以拒絕處理而非取消',
      BOOKING_NOT_CANCELLABLE: '此預訂不可取消',
      CANCEL_NOT_STARTED: '取消流程尚未開始',
      CANCEL_REFUND_CHANGED: '取消費或退款金額已變更',
      BOOKING_ADAPTER_BOOKING_NOT_CANCELLABLE: '供應商拒絕了取消',
      BOOKING_ADAPTER_EXTERNAL_FAILED: '供應商拒絕了取消',
      BOOKING_ADAPTER_EXTERNAL_PENDING: '正在等待供應商確認，請稍後重試',
      RETRYABLE: '請稍後重試',
      UNKNOWN: '此預訂不可取消'
    },
    cancelDeadline: '取消期限：{{deadline}}',
    language: {
      JAPANESE: '日文',
      ENGLISH: '英文',
      CHINESE: '中文（簡體）',
      CHINESE_T: '中文（繁體）',
      KOREAN: '韓文'
    },
    partnerCategory: {
      RAILWAY: '鐵道',
      BUS: '巴士',
      FERRIES: '渡輪',
      RENTAL_CAR: '租車',
      SIGHTSEEING_SPOT: '觀光景點',
      FOOD: '餐廳',
      EXPERIENCE: '體驗',
      ACCOMMODATION: '飯店',
      TOUR: '行程',
      ACTIVITY: '活動',
      CHARTER: '包車',
      LINKTIVITY: 'LINKTIVITY',
      OTHERS: '其他'
    },
    privacyPolicyType: {
      EMAIL_NOT_SHOW: '隱藏客戶電子郵件',
      NAME_NOT_SHOW: '隱藏客戶姓名',
      REGISTERED_CODE_NOT_SHOW: '隱藏預訂編號',
      OTA_BOOKING_ID_NOT_SHOW: '隱藏旅行社預訂編號',
      SUPPLIER_BOOKING_ID_NOT_SHOW: '隱藏催行公司預訂號碼'
    },
    transferFeePayer: {
      LINK: 'LINKTIVITY',
      SUPPLIER: '供應商'
    },
    billingMethod: {
      PURCHASE_DATE: '購買日',
      USAGE_DATE: '使用日'
    },
    systemFeeRefundPolicy: {
      NO_REFUND: '不退款',
      ALL_REFUND: '全額退款'
    },
    role: {
      ADMIN: '管理者',
      VIEWER: '檢視者',
      EDITOR: '編輯者',
      OPERATOR: '操作人員'
    },
    contractType: {
      equivalent: 'TERM_OF_SERVICE_V20181101 等效項',
      nonEquivalent: 'TERM_OF_SERVICE_V20181101 非等效'
    },
    checklistType: {
      RESTRICTION: '參加限制',
      REQUIRED_ITEM_TO_BRING_AND_ATTIRE: '需要攜帶的衣物和物品',
      REQUIRED_OTHER: '參與所需的其他事項',
      REQUIRED_ADDITIONAL_NOTE: '備註/其他',
      NICE_TO_HAVE_ITEM_TO_BRING_AND_ATTIRE: '建議攜帶的衣物和物品',
      NICE_TO_HAVE_OTHER: '其他建議',
      INCLUDED: '包含內容'
    },
    notificationType: {
      [NotificationType.NoNotification]: '無通知',
      [NotificationType.ActivityOperation]: '商品相關',
      [NotificationType.BookOperation]: '預約相關',
      [NotificationType.FinanceOperation]: '結算・財務相關',
      [NotificationType.SystemOperation]: '來自LINK的通知'
    },
    inboxCategory: {
      [NotificationType.ActivityOperation]: '商品相關',
      [NotificationType.BookOperation]: '預約相關',
      [NotificationType.FinanceOperation]: '結算・財務相關',
      [NotificationType.SystemOperation]: '來自LINK的通知',
      [NotificationType.UndefinedNotification]: '其他',
      [NotificationType.NoNotification]: '無'
    },
    notificationMethod: {
      [NotificationMethod.UndefinedMethod]: '未定義',
      [NotificationMethod.Email]: '電子郵件',
      [NotificationMethod.InternalMessage]: '站內信'
    },
    paymentType: {
      [PaymentType.PostBankTransfer]: '後付（銀行轉帳）',
      [PaymentType.PreLinkpay]: '線上付款（預付款）',
      [PaymentType.PostLinkpay]: '後付（LinkPay）',
      [PaymentType.PreCharge]: '銀行轉帳（預付款）'
    },
    paymentPeriod: {
      [PaymentPeriod.Weekly]: '週',
      [PaymentPeriod.Monthly]: '月',
      [PaymentPeriod.HalfMonthly]: '雙週'
    },
    attachmentType: {
      PDF: 'PDF',
      IMAGE: '圖片'
    },
    bookingField: {
      PARTICIPANT_EMAIL_ADDRESS: '參加者電子郵件',
      HOTEL_NAME: '住宿名稱',
      HOTEL_ADDRESS: '住宿地址',
      HOTEL_RESERVATION_LAST_NAME: '住宿代表人姓名（姓）',
      HOTEL_RESERVATION_FIRST_NAME: '住宿代表人姓名（名）',
      HOTEL_TEL: '住宿電話號碼',
      ARRIVAL_DATE: '當地抵達日',
      ARRIVAL_TIME: '抵達時間',
      ARRIVAL_FLIGHT_NUMBER: '航班抵達班次',
      DEPARTURE_DATE: '出發日',
      DEPARTURE_TIME: '出發時間',
      DEPARTURE_FLIGHT_NUMBER: '航班出發班次',
      DESTINATION_EMAIL: '當地聯絡方式（電子郵件）',
      DESTINATION_TEL: '當地聯絡方式（電話號碼）',
      PARTICIPANT_RESIDENT_REGION: '參加者居住國家/地區',
      PARTICIPANT_LANGUAGE: '參加者語言'
    },
    extendedBookingField: {
      PASSENGERS_QUANTITY: '乘車人數',
      PREFERRED_START_TIME: '希望開始時間',
      PREFERRED_PICK_UP_LOCATION: '接送／上車地點',
      PREFERRED_DROP_OFF_LOCATION: '送達／下車地點',
      PARTICIPANTS_QUANTITY: '參加人數',
      LUGGAGE_QUANTITY: '行李箱數量（總計）',
      CHILDREN_WITHOUT_SEAT_QUANTITY: '不需要座椅的嬰兒',
      CHILD_SEAT_QUANTITY_PAID: '是否使用兒童座椅 ※現場付款',
      CHILD_SEAT_QUANTITY_FREE: '是否使用兒童座椅 ※免費',
      PREFERRED_GUIDE_LANGUAGE_CODE: '希望導覽語言',
      PREFERRED_DRIVER_LANGUAGE_CODE: '希望司機對應的語言'
    },
    extendedParticipantField: {
      PASSPORT_FIRST_NAME: '參加者名字（護照羅馬拼音）',
      PASSPORT_LAST_NAME: '參加者姓氏（護照羅馬拼音）',
      PASSPORT_NATIONALITY: '國籍',
      PASSPORT_NUMBER: '護照號碼',
      DATE_OF_BIRTH: '出生日期',
      AGE: '年齡',
      GENDER: '性別',
      EYESIGHT: '視力',
      WEIGHT_KG: '體重（kg）',
      HEIGHT_CM: '身高（cm）',
      SHOE_SIZE_CM: '鞋碼（cm）',
      CLOTHES_SIZE: '衣服尺寸',
      VEGETARIAN_MEALS: '素食餐需求',
      DIVING_EXPERIENCE_TIMES: '潛水經驗次數',
      RENTAL_EQUIPMENTS_FREE: '是否需要器材租借 ※免費',
      RENTAL_EQUIPMENTS_PAY_LOCALLY: '是否需要器材租借 ※現場付款'
    },
    bookingStatus: {
      REQUEST_PENDING: '需求',
      REQUEST_REJECTED: '已拒絕',
      CONFIRMED: '已確定',
      CANCELLED_BY_TRAVELER: '取消（客戶）',
      CANCELLED_BY_SUPPLIER: '取消（供應商）',
      INVALID: '作廢',
      CANCEL_FAILED: '取消失敗',
      CANCEL_PENDING: '取消保留中'
    },
    bulkBookingStatus: {
      SUBMITTED: '已提交',
      PAID: '已匯款',
      ACCEPTED: '已核准',
      QUEUED: '待發行',
      ISSUED: '已發行',
      PENDING: '保留中'
    },
    bulkBookingAction: {
      SUBMIT: '提交',
      PAY: '匯款',
      ACCEPT: '核准',
      PEND: '保留',
      ISSUE: '出票',
      FINISH: '完成'
    },
    confirmationType: {
      [ConfirmationType.FreeSale]: '指定參加日（無庫存限制）',
      [ConfirmationType.FreeSaleOpenDate]: '無需指定參加日（無庫存限制）',
      [ConfirmationType.Inventory]: '請指定參與日期（即時）',
      [ConfirmationType.Request]: '請指定您希望參加的日期（申請）。'
    },
    // use for bookingDetail page
    bookingConfirmationType: {
      [ConfirmationType.FreeSale]: '無庫存限制',
      [ConfirmationType.FreeSaleOpenDate]: '無庫存限制',
      [ConfirmationType.Inventory]: '即時預訂',
      [ConfirmationType.Request]: '非即時預訂'
    },
    walletOrderStatus: {
      [WalletOrderStatus.StatusPending]: '未付款',
      [WalletOrderStatus.StatusPaying]: '儲值未完成',
      [WalletOrderStatus.StatusPaid]: '匯款完成',
      [WalletOrderStatus.StatusRejected]: '已拒絕',
      [WalletOrderStatus.StatusCancelled]: '已取消',
      [WalletOrderStatus.StatusConfirmed]: '儲值完成',
      [WalletOrderStatus.StatusRefunded]: '已退款'
    },
    transactionTypeMap: {
      [TransactionTypeMap.TransactionTypeCancelRefund]: '已取消',
      [TransactionTypeMap.TransactionTypePurchase]: '已確認',
      [TransactionTypeMap.TransactionTypeDiscrepancy]: '差額已調整',
      [TransactionTypeMap.TransactionTypeInvalid]: '已失效'
    },
    discrepancyStatus: {
      [DiscrepancyStatus.Waiting]: '待審核',
      [DiscrepancyStatus.Approved]: '調整完成',
      [DiscrepancyStatus.Rejected]: '已駁回'
    },
    discrepancyWaitingStatus: {
      [DiscrepancyWaitingStatus.Deliver]: '待審核',
      [DiscrepancyWaitingStatus.Receive]: '待處理審核'
    },
    discrepancyInitiator: {
      [DiscrepancyInitiator.Ota]: '旅行社',
      [DiscrepancyInitiator.Supplier]: '供應商'
    },
    discrepancyType: {
      [DiscrepancyType.Refund]: '退款',
      [DiscrepancyType.AdditionalCharge]: '追加請款'
    },
    discrepancyReason: {
      [DiscrepancyReason.AdditionalServices]: '商品追加費用',
      [DiscrepancyReason.MissedServices]: '因未提供服務退款',
      [DiscrepancyReason.CustomerComplaint]: '因客訴退款',
      [DiscrepancyReason.DoubleCharge]: '重複請款',
      [DiscrepancyReason.FeeForBookingChange]: '變更手續費',
      [DiscrepancyReason.PartialCancel]: '部分取消',
      [DiscrepancyReason.SelfAdjustment]: '個別調整',
      [DiscrepancyReason.Other]: '其他'
    },
    bookingType: {
      [BookingType.Bulk]: '批次處理',
      [BookingType.Single]: '個別處理'
    },
    issuedStatus: {
      [IssuedStatus.Issued]: '已使用',
      [IssuedStatus.NotIssued]: '未使用',
      [IssuedStatus.Partial]: '部分使用',
      [IssuedStatus.Disable]: '無效'
    },
    cancelReason: {
      [CancelReason.BadWeather]: '惡劣天氣',
      [CancelReason.BookedByMistake]: '誤訂',
      [CancelReason.DoubleBooking]: '重複預訂',
      [CancelReason.FlightIssues]: '航班取消／延誤／變更',
      [CancelReason.FoundCheaperRate]: '找到更便宜價格',
      [CancelReason.Other]: '其他',
      [CancelReason.ParticipantMinimumNotMet]: '未達最低成團人數',
      [CancelReason.ParticipantOrDateChange]: '更改預訂日或人數',
      [CancelReason.PrivateBuyout]: '團體包場／客滿',
      [CancelReason.SameSupplierActivityChange]: '更改為同一供應商商品',
      [CancelReason.SeparateSupplierActivityChange]: '更改為其他供應商商品',
      [CancelReason.Sickness]: '身體不適',
      [CancelReason.OtaCancelWithoutReason]: 'OTA原因取消',
      [CancelReason.TechnicalDifficulties]: '設備故障或突發問題'
    },
    category: {
      RAILWAY_TICKET: '鐵路車票',
      AIRPORT_TRANSPORTATION: '機場交通',
      SHINKANSEN: '新幹線',
      EXPRESS_BUS: '高速巴士',
      BUS_TOUR: '巴士行程',
      CRUISES: '渡輪・郵輪',
      RENTAL_CAR: '租車',
      CHARTER: '包車',
      ATTRACTION: '設施（入場券）',
      THEME_PARK: '主題樂園',
      MUSEUM_GALLERY: '博物館・美術館',
      AQUARIUM_ZOO: '水族館・動物園',
      TEMPLES_SHINES: '寺廟・神社・佛寺',
      TOWER_BUILDING: '觀景台・塔',
      JAPANESE_RESTAURANT: '日式餐廳',
      WESTERN_RESTAURANT: '西式餐廳',
      CHINESE_RESTAURANT: '中式餐廳',
      OTHER_RESTAURANT: '餐廳（其他）',
      DESSERT_BEVERAGE: '甜點・飲品',
      SIGHTSEEING_TOUR: '觀光行程',
      MARINE_SPORTS: '海上運動',
      OUTDOOR_ACTIVITIES: '戶外活動',
      ONSEN: '溫泉',
      SPA_MASSAGE: '水療・按摩',
      JAPANESE_CULTURAL_EXPERIENCE: '日本文化體驗',
      JAPANESE_CRAFT_EXPERIENCE: '日本工藝體驗',
      JAPANESE_COOKING_EXPERIENCE: '和食製作體驗',
      OTHER_EXPERIENCE: '其他體驗',
      HOTEL: '飯店',
      RYOKAN: '旅館',
      VACATION_RENTAL: '民宿',
      BUNDLE: '套票',
      PASS: '通票',
      OTHERS: '其他'
    },
    possibleIntervalShow: {
      DAY: '{{amount}}日內',
      MONTH: '{{amount}}個月內'
    },
    voucherExpirationFromPurchase: {
      DAY: '自購買日起{{time}}日內',
      MONTH: '自購買日起{{time}}個月內',
      SAME_DAY: '購買日當日'
    },
    voucherExpirationFromActivity: {
      DAY: '自參加日起{{time}}日內',
      MONTH: '自參加日起{{time}}個月內',
      SAME_DAY: '參加日當日'
    }
  },
  week: {
    SUNDAY: '日',
    MONDAY: '一',
    TUESDAY: '二',
    WEDNESDAY: '三',
    THURSDAY: '四',
    FRIDAY: '五',
    SATURDAY: '六'
  },
  bankInfo: {
    swiftCode: 'SWIFT代碼',
    bankName: '銀行名稱',
    bankCode: '銀行帳戶',
    bankBranchCode: '分行代碼',
    bankBranchName: '分行名稱',
    bankAddress: '銀行地址',
    bankAccountNumber: '帳戶',
    accountHolderName: '帳戶名'
  },
  validation: {
    required: '{{name}}為必填項目',
    invalid: '請輸入有效的{{name}}',
    password: '請使用半形英數字與符號組合，並輸入8個字元以上',
    imageType: '請選擇圖片',
    fileSize: '請選擇{{size}}MB以下的檔案',
    range: '{{name}}請輸入{{min}}～{{max}}之間的值',
    greaterThan: '{{name}}請輸入大於{{min}}的值',
    notEqual: '{{name}}不可輸入{{value}}',
    integer: '{{name}}請輸入整數',
    requiredSelect: '請選擇',
    alphabet: '請輸入半形英文字母（可含空格，不可含數字）',
    otaCustomIdFormat: '請輸入1~16位大寫字母、數字或底線，且以字母或數字開頭',
    maxLength: '{{name}}請輸入{{max}}個字元以內',
    personName: "{{name}}不可包含數字或特殊符號（可使用 ' - .）",
    telFormat: '請僅使用數字、「+」、「-」，且長度為8~20位',
    flightNumber: '請輸入3~8位半形英數字，且須同時包含英文字母與數字',
    dateNotBefore: '{{name}}請輸入{{min}}或之後的日期',
    dateNotAfter: '{{name}}請輸入{{max}}或之前的日期',
    passportName: "請依護照記載的羅馬拼音輸入（僅半形英文字母、空白及 ' - .）",
    passportNumber: '請輸入6~12位半形英數字',
    ageMismatch: '與根據出生年月日計算的年齡（{{age}}歲）不一致'
  },
  messages: {
    newSuccess: '已新增',
    updateSuccess: '已更新',
    deleteSuccess: '已刪除',
    copySuccess: '已複製',
    updateFailed: '更新失敗',
    dateMax3Months: '日期範圍請設定為3個月以內',
    downloadSuccess: '下載完成'
  },
  confirmDelete: {
    title: '請確認',
    prompt: '是否確定刪除？'
  },
  autoLogout: {
    title: '即將自動登出',
    description1: '為了安全，9小時未操作將自動登出。',
    description2: '如需繼續使用，請點擊「繼續」。',
    logout: '立即登出',
    continue: '繼續'
  },
  firebase: {
    'auth/invalid-credential': '登入名稱或密碼不正確。',
    'auth/email-already-in-use': '此電子郵件已被註冊。',
    'auth/too-many-requests': '登入嘗試次數已達上限，請稍後再試或重設密碼。'
  },
  wallet: {
    feeRate: '手續費率',
    fee: '手續費',
    deductAmount: '合計金額',
    proceedToPayment: '同意並前往付款',
    invalidAmount: '請輸入正確的金額'
  },
  transaction: {
    csvApplyDateTimezoneNote:
      '※注意：結算明細CSV的申請日期採用的是供應商設定的商品時區時間，而非旅行代理店的本地（瀏覽器）時間。'
  },
  activityDetail: {
    title: '商品詳情',
    planTitle: '方案詳情',
    faq: 'FAQ',
    location: '{{country}}',
    city: '・{{city}}',
    activity: {
      content: '商品內容',
      api: 'API Code',
      cancelPolicy: '取消政策',
      productId: '商品ID',
      operator: '供應商',
      timezone: '時區',
      currency: '貨幣',
      language: '翻譯語言',
      category: '分類',
      departure: '出發地',
      destination: '目的地',
      activityId: '活動ID',
      activityName: '活動名稱',
      planId: '方案ID',
      planName: '方案名稱',
      planStartTimeId: '方案開始時間ID',
      planStartTimeName: '方案開始時間名稱',
      startTime: '開始時間',
      planUnitItemsId: '方案單位項目ID',
      planUnitName: '方案單位名稱'
    },
    plans: {
      description: '預訂資訊',
      notes: '注意事項',
      schedule: '行程',
      locations: '地點',
      additionalBookingInfo: '追加預約資訊',
      startTime: '開始時間',
      noTimeLimit: '無限制',
      availableCount: '可預訂數量',
      availableCountShow: '{{min}} ~ {{max}}',
      availablePeriod: '公開期間',
      availablePeriodShow:
        '{{startY}}-{{startM}}-{{startD}} ~ {{endY}}-{{endM}}-{{endD}}',
      possibleInterval: '可預訂期間',
      reservationDeadline: '預訂截止時間',
      reservationDeadlineShow: '請於參加日前{{day}}天的{{time}}前完成預訂。',
      reservationDeadlineShowToday: '請於當日{{time}}前完成預訂。',
      voucherExpiration: '憑證有效期限',
      voucherExpirationAnnualCutOff:
        '年度基準日：{{annualFixedDate}}之前購買的訂單將於當年相對日期：{{annualCutOffDate}}失效；年度基準日：{{annualFixedDate}}之後購買的訂單將於翌年相對日期：{{annualCutOffDate}}失效',
      optionalBookingFields: '代表人資訊（選填）',
      optionalExtendedBookingFields: '其他資訊（選填）',
      optionalParticipantFields: '參加者資訊※每位參加者（選填）',
      requiredBookingFields: '代表人資訊（必填）',
      requiredExtendedBookingFields: '其他資訊（必填）',
      requiredParticipantFields: '參加者資訊※每位參加者（必填）',
      customFields: '自訂預訂資訊',
      customFieldsShow: '{{title}} : {{des}}',
      meetingPlace: '集合地點',
      dismissalPlace: '解散地點',
      pickupPlace: '接送地點',
      dropOffPlace: '送達地點'
    }
  }
};
